import { fork } from 'redux-saga/effects';
import { documentCardConfigWatcher } from './documentCardSaga';
export default function* DocumentCard() {
  yield fork(documentCardConfigWatcher);
}
